import editorService from '@/services/ide/editor.service'

/**
 * Sets font size of current editor
 * @param e Select Event
 */
const changeIdeFontSize = (e: Event) => {
  editorService.setFontSize(parseInt((e.target as HTMLSelectElement).value))
}

export default { changeIdeFontSize }
